export const validateMixin = {
  methods: {
    isValidProp(object, keys, defaultVal = 'N/A') {
      keys = Array.isArray(keys) ? keys : keys.split('.')
      object = object[keys[0]]
      if (object && keys.length > 1) {
        return this.isValidProp(object, keys.slice(1), defaultVal)
      }
      return object === undefined || object === '' || object === null
        ? defaultVal
        : object
    }
  }
}
